/** @jsx jsx */
import { type Interpolation, type Theme, css, jsx } from '@emotion/react';

import { OverflowCarousel } from '@coursera-web/cds-labs';

import { Typography2, breakpoints } from '@coursera/cds-core';

import DomainIcon from 'bundles/unified-common/components/pill/DomainIcon';
import Pill from 'bundles/unified-common/components/pill/Pill';

import _t from 'i18n!nls/partners-graphql';

type Domain = {
  slug: string;
  name: string;
};

type Props = {
  domains: Domain[];
  pillsCss?: Interpolation<Theme>;
};

const defaultPillsCss = css`
  display: flex;
  gap: var(--cds-spacing-100);
  flex-wrap: wrap;

  ${breakpoints.down('xs')} {
    flex-wrap: nowrap;
  }
`;

const styles = {
  section: css`
    margin-top: var(--cds-spacing-300);
    margin-bottom: var(--cds-spacing-300);
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-150);
  `,
  pill: css`
    white-space: nowrap;
  `,
};

const ExploreCategoriesSection = ({ domains, pillsCss }: Props) => {
  if (!domains?.length) {
    return null;
  }

  return (
    <div css={styles.section}>
      <Typography2 component="h2" variant="subtitleLarge">
        {_t('Explore categories')}
      </Typography2>
      <OverflowCarousel css={pillsCss ?? defaultPillsCss} shouldAllowSpaceForHoverItems>
        {domains.map((domain) => (
          <Pill key={domain.slug} href={`/browse/${domain.slug}`} css={styles.pill}>
            <DomainIcon domain={{ id: domain.slug, name: domain.name, slug: domain.slug }} />
            {domain.name}
          </Pill>
        ))}
      </OverflowCarousel>
    </div>
  );
};

export default ExploreCategoriesSection;
